import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSC_NT_AI_ApplicationInformation = createAsyncThunk(
  "SC_NT_AI_ApplicationInformation/GetOneSC_NT_AI_ApplicationInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_NT_AI_ApplicationInformation/GetOneSC_NT_AI_ApplicationInformation",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateSC_NT_AI_ApplicationInformation = createAsyncThunk(
  "SC_NT_AI_ApplicationInformation/UpdateSC_NT_AI_ApplicationInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_NT_AI_ApplicationInformation/UpdateSC_NT_AI_ApplicationInformation",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SC_NT_AI_ApplicationInformation = createSlice({
  name: "SC_NT_AI_ApplicationInformation",
  initialState: {
    //------------- GetSC_NT_AI_ApplicationInformation ---------------------
    SC_NT_AI_ApplicationInformation: {},
    loadingSC_NT_AI_ApplicationInformation: false,
    errorSC_NT_AI_ApplicationInformation: null,
    //------------- UpdateSC_NT_AI_ApplicationInformation ---------------------
    SC_NT_AI_ApplicationInformationUpdate: {},
    loadingSC_NT_AI_ApplicationInformationUpdate: false,
    errorSC_NT_AI_ApplicationInformationUpdate: null,
  },
  reducers: {
    setSC_NT_AI_ApplicationInformation: (state, action) => {
      state.SC_NT_AI_ApplicationInformation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneSC_NT_AI_ApplicationInformation.pending,
        (state, action) => {
          console.log(action.payload, "action.payload");

          state.loadingSC_NT_AI_ApplicationInformation = true;
          state.SC_NT_AI_ApplicationInformation = action.payload;
          state.errorSC_NT_AI_ApplicationInformation = null;
        }
      )
      .addCase(
        GetOneSC_NT_AI_ApplicationInformation.fulfilled,
        (state, action) => {
          state.loadingSC_NT_AI_ApplicationInformation = false;
          state.SC_NT_AI_ApplicationInformation = action.payload;
        }
      )
      .addCase(
        GetOneSC_NT_AI_ApplicationInformation.rejected,
        (state, action) => {
          state.loadingSC_NT_AI_ApplicationInformation = false;
          state.SC_NT_AI_ApplicationInformation = action.payload;
        }
      );
    //------------------- UpdateSC_NT_AI_ApplicationInformation -----------------------------------
    builder
      .addCase(
        UpdateSC_NT_AI_ApplicationInformation.pending,
        (state, action) => {
          state.loadingSC_NT_AI_ApplicationInformationUpdate = true;
          state.SC_NT_AI_ApplicationInformationUpdate = action.payload;
          state.errorSC_NT_AI_ApplicationInformationUpdate = null;
        }
      )
      .addCase(
        UpdateSC_NT_AI_ApplicationInformation.fulfilled,
        (state, action) => {
          state.loadingSC_NT_AI_ApplicationInformationUpdate = false;
          state.SC_NT_AI_ApplicationInformationUpdate = action.payload;
        }
      )
      .addCase(
        UpdateSC_NT_AI_ApplicationInformation.rejected,
        (state, action) => {
          state.loadingSC_NT_AI_ApplicationInformationUpdate = false;
          state.errorSC_NT_AI_ApplicationInformationUpdate = action.payload;
        }
      );
  },
});
export const { setSC_NT_AI_ApplicationInformation } =
  SC_NT_AI_ApplicationInformation.actions;
export default SC_NT_AI_ApplicationInformation.reducer;
